/* eslint-disable react/require-default-props */
import { Formik, Form } from 'formik';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import InputGroup from './InputGroup';
import { Appointment, GeneralRequest, InputGroupType } from '../../interfaces';
import './form.css';

interface Props {
  initFormValues: any;
  validationSchema: any;
  inputGroups: any;
  submitAction: any;
  selectedAppointment?: Appointment | GeneralRequest;
  formError: string;
}

export default function ReuseableForm({
  initFormValues,
  validationSchema,
  inputGroups,
  submitAction,
  selectedAppointment,
  formError,
}: Props) {
  const loadedFormValues = { ...initFormValues };

  if (selectedAppointment) {
    if (
      loadedFormValues.artist === '' &&
      (selectedAppointment as Appointment).employeeId
    ) {
      loadedFormValues.artist = (selectedAppointment as Appointment).employeeId;
    }
  }

  return (
    <Box>
      {formError && (
        <Typography variant="body1" color="primary">
          {formError}
        </Typography>
      )}
      <Formik
        enableReinitialize
        initialValues={loadedFormValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          if (selectedAppointment) {
            submitAction(selectedAppointment, values);
          } else {
            submitAction(values);
          }
          setSubmitting(false);
        }}>
        {({ isSubmitting }) => (
          <Form>
            {inputGroups.map((inputGroup: InputGroupType) => (
              <InputGroup
                name={inputGroup.name}
                rows={inputGroup.inputRows}
                key={inputGroup.name}
              />
            ))}
            <Button
              type="submit"
              disabled={isSubmitting}
              variant="contained"
              className="primary">
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
